import React from 'react';

import cx from 'classnames';
import { prop } from 'ramda';
import { useSelector } from 'react-redux';
import { Link, scroller } from 'react-scroll';

import { getOriginTitle } from 'components/Pages/Admin/Page/Landing/utils';
import { LANDING_PAGES_CONTAINER_ID } from 'components/shared/LandingPage/components/Grid';
import { itineraryCurrentPageEmptySelector, itineraryCurrentPageHiddenSelector } from 'store/itinerariesItem/selectors';
import { isDefined } from 'utils/ramda';

import s from './index.module.css';

function Item(props) {
  const {
    index,
    link,
    getDates,
    baseOffset,
    clickOffset,
    onActive,
    isPortalItinerary,
    leftSideNavigation,
    classname,
    setActiveIndex,
    activeIndex,
    setIsOpen,
    spy = true,
  } = props;
  const pageHidden = useSelector((state) => itineraryCurrentPageHiddenSelector(state, index));
  const pageEmpty = useSelector((state) => itineraryCurrentPageEmptySelector(state, index));
  const hidden = isPortalItinerary ? false : pageHidden || pageEmpty;

  const realTitle = getOriginTitle(link);
  const isEmptyItem = !realTitle;
  const linkId = leftSideNavigation ? `leftSideNav_${index}${link}` : `${index}${link}`;

  const isFirst = index === 0;
  const linkText = isEmptyItem ? 'Section Name' : realTitle;

  const onActiveLink = (value, index) => {
    onActive(`${index}${value}`);
    leftSideNavigation && setActiveIndex(value);
  };

  return (
    <div id={linkId} className={cx(leftSideNavigation && s.leftSideItem, s.item, isEmptyItem && prop('empty', s))}>
      <div className={s.itemBlock}>
        <Link
          to={link}
          id={linkId}
          className={cx(
            leftSideNavigation && s.leftSideLink,
            s.link,
            !leftSideNavigation && 'custom-landing-page-mobile-nav-link',
            leftSideNavigation && 'custom-landing-page-burger-nav-link',
            classname,
          )}
          activeClass={cx(
            leftSideNavigation && s.activeLeftSideLink,
            s.linkActive,
            !leftSideNavigation && 'custom-landing-page-mobile-nav-active-link',
            leftSideNavigation && 'custom-landing-page-burger-nav-active-link',
          )}
          containerId={LANDING_PAGES_CONTAINER_ID}
          smooth={true}
          duration={200}
          spy={spy}
          offset={baseOffset(isFirst)}
          ignoreCancelEvents={false}
          isDynamic={true}
          onClick={() => {
            leftSideNavigation && setIsOpen(false);
            setTimeout(() => {
              scroller.scrollTo(link, {
                containerId: LANDING_PAGES_CONTAINER_ID,
                smooth: true,
                duration: 200,
                offset: clickOffset(isFirst),
              });
            }, [150]);
          }}
          onSetActive={(value) => onActiveLink(value, index)}
          data-testid={linkId}
        >
          <Wrapper hidden={hidden} leftSideNavigation={leftSideNavigation}>
            <div className={s.textBlock}>
              {leftSideNavigation && <span className={cx(activeIndex === link && s.itemLineActive, s.itemLine)}></span>}
              {linkText}
            </div>
            {getDates && (
              <div className={cx(s.itemDates, !isDefined(getDates(linkText, index)) && s.defaultItemDates)}>
                {getDates(linkText, index)}
              </div>
            )}
          </Wrapper>
        </Link>
      </div>
    </div>
  );
}

export default React.memo(Item);

function Wrapper({ hidden, children, leftSideNavigation }) {
  if (hidden) return <s data-block>{children}</s>;
  return (
    <span data-block className={leftSideNavigation && s.linkText}>
      {children}
    </span>
  );
}
